import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import { colorsV2 } from '../../../colors-v2';

export const COUNT_ITEM = 'count_item';

const NumberWrapper = styled.span<{ isShow }>`
  user-select: none;
  height: 24px;
  width: 24px;
  margin-right: 8px;
  border-radius: 50%;
  text-align: center;
  align-content: center;
  align-items: center;
  display: ${(p) => (p.isShow ? 'inline-block' : 'none')};
  color: ${colorsV2.white100};
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  background: ${colorsV2.gray100};
  box-sizing: border-box;
  position: relative;
  bottom: 3px;
`;
export const renderSentenceCountElement = () => ({ element }: RenderElementProps) => {
  if (element.type === COUNT_ITEM) {
    const { number, isShow } = element;
    return (
      <NumberWrapper id={`count-item-${number}`} isShow={isShow} contentEditable={false}>
        {number}
      </NumberWrapper>
    );
  }
  return null;
};
